import React, {Component} from "react";

import {estilos} from '../util/estilos'

import CurrencyInput from 'react-native-currency-input';

import * as numeros from '../util/numeros'



export default class  CampoNumero extends Component {


	constructor(props) {
        
        super(props);
    }


    render() {
        return(
			<CurrencyInput
				value={numeros.transformaEmNumeroValido(this.props.valor)}
				onChangeValue={(valor) => this.props.setValor(numeros.transformaEmNumeroValido(valor))} 
				prefix={this.props.prefixo}
				delimiter={this.props.casasDecimais==0?"":"."}
				separator=","
				precision={this.props.casasDecimais==null?2:this.props.casasDecimais}
				minValue={0}
				style={estilos.campo_padrao}/>)    
   }
}